export default "__VITE_ASSET__CUhnnzm4__"